export default {
  namespaced: true,
  vlm_configuration: {
    title: "Configuração de VLM",
    subtitle: "Prepare a política de análise de vídeo sem enviar conteúdo a provedores externos.",
    list_subtitle: "Gerencie as configurações de análise de vídeo disponíveis.",
    new_configuration: "Nova configuração VLM",
    edit_configuration: "Editar configuração VLM",
    add_configuration: "Adicionar configuração",
    back_to_list: "Voltar à lista",
    name: "Nome da configuração",
    name_placeholder: "Ex. Segurança da planta norte",
    empty_list: "Ainda não há configurações VLM.",
    delete_configuration: "Excluir configuração",
    delete_confirmation: "Deseja excluir a configuração \"{name}\"? Esta ação não pode ser desfeita.",
    delete: "Excluir",
    cancel: "Cancelar",
    cameras: "Câmeras",
    cameras_hint: "Selecione as câmeras reais usadas por esta configuração.",
    prompt: "Instrução de análise",
    prompt_placeholder: "Descreva o que o modelo deve identificar no vídeo.",
    presets: "Exemplos rápidos",
    fallen_person: "Pessoa caída",
    fight: "Briga entre pessoas",
    disorder: "Área de trabalho desorganizada",
    model: "Modelo de IA",
    model_gemini_flash: "Gemini 2.5 Flash",
    model_gemini_pro: "Gemini 2.5 Pro",
    model_openai: "OpenAI GPT-5.6 Terra",
    model_gemini_description: "Processamento de vídeo nativo para análise multimodal.",
    model_openai_description: "Análise de frames; não processa streams de vídeo nativos.",
    analysis_policy: "Política de análise",
    enabled: "Ativar configuração VLM",
    sampling_interval: "Intervalo de amostragem",
    confidence_threshold: "Limite de confiança",
    seconds: "segundos",
    summary: "Resumo",
    selected_cameras: "Câmeras selecionadas",
    service_status: "Status do serviço",
    active: "Ativo",
    inactive: "Inativo",
    updated_at: "Última atualização",
    not_saved: "Não salvo",
    save: "Salvar configuração",
    read_only: "Você não tem permissão para atualizar esta configuração.",
    load_error: "Não foi possível carregar a configuração VLM.",
    save_error: "Não foi possível salvar a configuração VLM.",
    saved: "Configuração VLM salva com sucesso.",
    created: "Configuração VLM criada com sucesso.",
    updated: "Configuração VLM atualizada com sucesso.",
    deleted: "Configuração VLM excluída com sucesso.",
    delete_error: "Não foi possível excluir a configuração VLM.",
    preset_fallen: "Analise o vídeo e identifique se há uma pessoa caída. Informe apenas achados com marca de tempo e nível de confiança.",
    preset_fight: "Analise o vídeo e identifique possíveis brigas ou agressões entre pessoas. Informe apenas achados com marca de tempo e nível de confiança.",
    preset_disorder: "Analise o vídeo e identifique áreas de trabalho desorganizadas ou obstruções relevantes. Informe apenas achados com marca de tempo e nível de confiança.",
  },
};
